import { render, staticRenderFns } from "./OccurrenceDetails.vue?vue&type=template&id=ca9a3aba&scoped=true&"
import script from "./OccurrenceDetails.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetails.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDetails.vue?vue&type=style&index=0&id=ca9a3aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9a3aba",
  null
  
)

export default component.exports